var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"food-flx"},[_c('div',{staticClass:"food-flx-item"},[_c('img',{attrs:{"src":require("@assets/img/home/food_icon.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm._f("formatNumber")(_vm.num)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }